import React, { useState } from 'react';
import { UserCircle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export const AVATARS = [
  'aj-soprano', 'brett', 'bruce-lee', 'butch-coolidge', 'christopher',
  'dr-melfi', 'elvira-hancock', 'frank-lopez', 'gustavo-fring', 'hank',
  'henry-hill', 'honey-bunny', 'jesse', 'jimmie', 'jimmy-conway',
  'jules-winfield', 'karen-hill', 'lance', 'manny-ribera', 'marsellus-wallace',
  'maynard', 'mia-wallace', 'mike', 'mr-brown', 'mr-wolf',
  'paul-cicero', 'paulie-walnuts', 'pumpkin', 'saul', 'silvio-dante',
  'skyler', 'the-bad', 'the-good', 'the-ugly', 'the-wolf',
  'tony-devito', 'tony-montana', 'tony-soprano', 'tyson', 'vincent-vega',
  'vincent-vega-young', 'walter-white', 'zed',
];

export function avatarLabel(slug) {
  return slug.split('-').map(w => w[0].toUpperCase() + w.slice(1)).join(' ');
}

export function AvatarDisplay({ avatar, name, className = '' }) {
  if (avatar) {
    return (
      <img
        src={`/avatars/${avatar}.png`}
        alt={name || avatar}
        className={`w-full h-full object-cover ${className}`}
      />
    );
  }
  return <UserCircle className="w-3/5 h-3/5 text-ink-dim" />;
}

export default function AvatarPicker({ open, onClose, current, onSelect }) {
  const [hovered, setHovered] = useState(null);
  const noAvatarSelected = !current;

  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="bg-surface-1 border-white/10 max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-ink font-display tracking-tight">Choose your avatar</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-8 gap-2 max-h-96 overflow-y-auto pr-1 mt-2">
          {/* No avatar tile */}
          <button
            title="No avatar"
            onClick={() => { onSelect(null); onClose(); }}
            onMouseEnter={() => setHovered('__none__')}
            onMouseLeave={() => setHovered(null)}
            className={`
              relative rounded-lg overflow-hidden aspect-square transition-all duration-150 flex items-center justify-center bg-surface-2
              ${noAvatarSelected ? 'ring-2 ring-primary-500 ring-offset-2 ring-offset-surface-1' : ''}
              ${hovered === '__none__' && !noAvatarSelected ? 'ring-1 ring-white/30' : ''}
              hover:scale-105
            `}
          >
            <UserCircle className="w-3/5 h-3/5 text-ink-dim" />
          </button>

          {AVATARS.map(slug => {
            const isSelected = current === slug;
            return (
              <button
                key={slug}
                title={avatarLabel(slug)}
                onClick={() => { onSelect(slug); onClose(); }}
                onMouseEnter={() => setHovered(slug)}
                onMouseLeave={() => setHovered(null)}
                className={`
                  relative rounded-lg overflow-hidden aspect-square transition-all duration-150
                  ${isSelected ? 'ring-2 ring-primary-500 ring-offset-2 ring-offset-surface-1' : ''}
                  ${hovered === slug && !isSelected ? 'ring-1 ring-white/30' : ''}
                  hover:scale-105
                `}
              >
                <img
                  src={`/avatars/${slug}.png`}
                  alt={avatarLabel(slug)}
                  className="w-full h-full object-cover"
                />
              </button>
            );
          })}
        </div>
        <p className="text-center text-xs text-ink-dim mt-2 h-4">
          {hovered === '__none__' ? 'No avatar' : hovered ? avatarLabel(hovered) : ''}
        </p>
      </DialogContent>
    </Dialog>
  );
}
